export const useStyles = (theme) => ({
  root: {
    padding: 10,
  },
  listitemRoot: {
    display: "flex",
    [theme.breakpoints.down(960)]: {
      display: "block",
    },
  },
  listitemContent: {
    width: "33%",
    marginRight: 5,
    [theme.breakpoints.down(960)]: {
      width: "100%",
    },
  },
  inputRoot: {
    height: 70,
  },
  tableFormWidth: {
    width: 150,
  },
  labelRoot: {
    fontSize: 18,
    fontWeight: "bold",
    backgroundColor: "#fff",
    paddingRight: 5,
  },
  notchedOutline: {},
  labelFocused: { color: "black !important" },
  focused: {
    "& $notchedOutline": {
      borderColor: "black !important",
    },
  },
  filterSelect: {
    width: "40%",
    [theme.breakpoints.down(700)]: {
      width: "100%",
    },
  },
});
